module.exports = __webpack_public_path__ + "static/shift-how-top-real-estate-agents-tackle-tough-times-paperback-e4d9768e087595a0fd12d450467ea6f2.jpg";